import {Injectable, OnInit} from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor } from '@angular/common/http';
import { Observable } from 'rxjs';
import { AuthService} from "../service/auth.service";
import {timeout} from "q";

@Injectable()
export class JwtInterceptor implements HttpInterceptor {

    constructor(private authService: AuthService){

    }

    intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>>  {


        const accessToken = this.authService.getAccessToken();
        if(accessToken){
            request = request.clone({
                setHeaders: {
                    Authorization: `Bearer ${accessToken}`
                }
            });
        }
        return next.handle(request);

    }
}